import React from 'react';
import {string, object} from 'prop-types';
import Icon from '../icon';
import './contact-info.css';

const ContactInfo = ({
  mobile,
  phone,
  email,
  address,
  acceptedPaymentMethods
}) => (
  <div className="contact-info">
    <h2>To Book</h2>
    <ul>
      <li>
        <a href={`https://wa.me/${mobile.replace(/ /g, '')}`}>
          <Icon name="whatsapp" /> {mobile}
        </a>
      </li>
      <li>
        <a href={`tel:${phone}`}>
          <Icon name="phone" /> {phone}
        </a>
      </li>
      <li>
        <a href={`mailto:${email}`}>
          <Icon name="mail" /> {email}
        </a>
      </li>
      <li className="contact-info__address">{address}</li>
    </ul>
    <h2>We Accept</h2>
    <img
      src={acceptedPaymentMethods.url}
      alt={acceptedPaymentMethods.alt}
      width="189"
      height="20"
    />
  </div>
);

ContactInfo.propTypes = {
  mobile: string.isRequired,
  phone: string.isRequired,
  email: string.isRequired,
  address: string.isRequired,
  acceptedPaymentMethods: object.isRequired
};

export default ContactInfo;
